<template>
    <div class="countNum">
      <div :style="{width: percent+'%',background:background}"></div>
    </div>
</template>
<script>
export default {
    props:['percent',"background"],
  data() {
    return {
      //health: 60,
      eable: false
    };
  },
  methods: {
    
  }
};
</script>
<style lang="">
.countNum {
  width: 100%;
  height: 10px;
  margin-top:5px;
  background: #144a8f;
  border-radius: 6px;
}

.countNum div {
  height: 10px;
  background: #24bcf4;
  border-radius: 6px;
}

.bu {
  width: 250px;
  margin: 0px auto;
}

.bu button {
  margin: 0 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/data/percent.vue